firebird
    .directive('fgLine', function () {
        return {
            restrict: 'C',
            link: function (scope, element) {
                if ($('.fg-line')[0]) {
                    $('body').on('focus', '.form-control', function () {
                        $(this).closest('.fg-line').addClass('fg-toggled');
                    });

                    $('body').on('blur', '.form-control', function () {
                        var p = $(this).closest('.form-group');
                        var i = p.find('.form-control').val();

                        if (p.hasClass('fg-float')) {
                            if (i.length === 0) {
                                $(this).closest('.fg-line').removeClass('fg-toggled');
                            }
                        } else {
                            $(this).closest('.fg-line').removeClass('fg-toggled');
                        }
                    });
                }
            }
        };
    })

    .directive('autoSize', function () {
        return {
            restrict: 'A',
            link: function (scope, element) {
                if (element[0]) {
                    autosize(element);
                }
            }
        };
    })

    .directive('ngEnter', function () {
        return function (scope, element, attrs) {
            element.bind('keydown keypress', function (event) {
                if (event.which === 13) {
                    scope.$apply(function () {
                        scope.$eval(attrs.ngEnter);
                    });

                    event.preventDefault();
                }
            });
        };
    })

    .directive('ngFocusOut', [
        '$timeout',
        function ($timeout) {
            return function ($scope, elem, attrs) {
                $scope.$watch(attrs.ngFocusOut, function (newval) {
                    if (newval) {
                        $timeout(
                            function () {
                                var element = angular.element(elem[0]);
                                element.removeClass('fg-toggled');
                            },
                            0,
                            false
                        );
                    }
                });
            };
        }
    ])

    .directive('focusOn', [
        '$timeout',
        function ($timeout) {
            return {
                restrict: 'A',
                link: function ($scope, $element, $attr) {
                    $scope.$watch($attr.focusOn, function (_focusVal) {
                        $timeout(function () {
                            if (_focusVal) {
                                $element[0].focus();
                            } else {
                                $element[0].blur();
                            }
                        });
                    });
                }
            };
        }
    ]);
